export enum ClassesEndpointsEnum {
  // SEEKER_CLASSES = "/products/classes/purchased",
  SEEKER_CLASSES = "/v2/getOngoingClasses",
  PRACTITIONER_CLASSES = "/practitioners/classes",
  ALL_CLASSES = "/v2/products?types=class",
  CANCEL_CLASS = "/class-type/:classId/cancel",
}
